import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import {
  INetworkName,
  NETWORK_NAMES,
  NETWORK_NAME_DEFAULT,
} from '@shared/constants'

import devconsole from '../utils/devconsole'
import routerSelectors from '../store/selectors/router'

const withNetworkName = (): INetworkName => {
  const params = useSelector(routerSelectors.params)
  const networkName = useMemo(() => {
    let networkName = NETWORK_NAME_DEFAULT
    if(params.network && NETWORK_NAMES.indexOf(params.network) >= 0) {
      networkName = params.network as INetworkName
    }
    devconsole.log(`network selector: param=${params.network}, result=${networkName}`)
    devconsole.dir(NETWORK_NAMES)
    return networkName
  }, [
    params.network,
  ])
  return networkName
}

export default withNetworkName